import { useQuery } from 'react-query'
import { request } from 'Features/auth/axios-client'

export const LEDGER_NOT_AVAILABLE = 'LEDGER_NOT_AVAILABLE'

// W1's signal: 404 {code: "LEDGER_NOT_AVAILABLE"} when a work centre has no
// PlanningBookLedger partition (a v1 plan). The page then shows Classic only.
export const isLedgerNotAvailable = (error: unknown): boolean => {
  const response = (
    error as { response?: { status?: number; data?: { code?: string } } }
  )?.response
  return (
    response?.status === 404 && response?.data?.code === LEDGER_NOT_AVAILABLE
  )
}

// Only a plan built by the V2 engine (its row carries jobExecutionName) can
// have a ledger, so the availability call is skipped for every other plan.
// Same query as useIsReadOnly, so the plan row is fetched once. The row's
// planData JSON carries planStartWeek ('yyyy-MM-dd'), which numbers the
// waterfall hover's plan weeks.
const planStartWeekOf = (planData: unknown): string | null => {
  try {
    const start = JSON.parse(String(planData ?? '{}'))?.planStartWeek
    return typeof start === 'string' ? start : null
  } catch {
    return null
  }
}

export const usePlanBuiltByV2Engine = (planId: string | undefined) => {
  const { data, isLoading } = useQuery(
    ['plan-details-user-access', planId],
    () => request({ url: `/operational-plan/${planId}` }),
    {
      cacheTime: 60 * 60 * 24,
      enabled: Boolean(planId),
      select: (response) => response?.data?.data,
    }
  )
  return {
    builtByV2Engine: Boolean(data?.jobExecutionName),
    planStartWeek: planStartWeekOf(data?.planData),
    isLoading,
  }
}
